import { Paper } from "@mantine/core";
import { partnerApi } from "apis/partnerApi";
import { Loading } from "components";
import { ErrorStatusType } from "constants/types/common";
import { PartnerCreateBodyType } from "constants/types/partner";
import { useFormik } from "formik";
import { FORM_IDS } from "pages/Partner/config";
import { FC, useState } from "react";
import { useNotification } from "utils/hooks";
import { useListRegion } from "utils/hooks/request/useRegions";
import PartnerFormFields from "../PartnerFormFields/PartnerFormFields";
import { createValidationSchema } from "./config";

interface CreateFormProps {
  onClose?: () => void;
  mutate?: () => void;
}

const CreateForm: FC<CreateFormProps> = ({ onClose, mutate }) => {
  const { notification } = useNotification();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { regionOptions, mutate: regionMutate } = useListRegion();

  const formik = useFormik<PartnerCreateBodyType>({
    initialValues: {
      code: "",
      name: "",
      type: "",
      regionId: "",
      phone: "",
      taxCode: "",
      contactPersonId: "",
      address: "",
      notes: "",
      isActive: true,
    },
    validationSchema: createValidationSchema,
    onSubmit: async (values) => {
      setIsSubmitting(true);
      try {
        const res = await partnerApi.create(values);
        if (res.data.success) {
          notification.success({ title: "Tạo đối tác thành công" });
          onClose?.();
          mutate?.();
          formik.resetForm();
        }
      } catch (error: ErrorStatusType | any) {
        notification.error({
          title: "Tạo đối tác thất bại",
          message: error?.error?.message,
        });
      }
      setIsSubmitting(false);
    },
  });

  return (
    <Loading variant="overlay" visible={isSubmitting}>
      <Paper>
        <form id={FORM_IDS.CREATE} onSubmit={formik.handleSubmit}>
          <PartnerFormFields
            formik={formik}
            regionOptions={regionOptions}
            onRegionMutate={regionMutate}
          />
        </form>
      </Paper>
    </Loading>
  );
};

export default CreateForm;
